export const PART_TAG_REGEX = /^\d{4}$/;
export const EMPLOYEE_ID_REGEX = /^[a-zA-Z\d]+\.[a-zA-Z\d]{1,3}$/;
